import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { TrendingUp, MessageCircle, Menu, X } from 'lucide-react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const whatsappLink = 'https://wa.me/56984413571?text=Hola%20quiero%20informaci%C3%B3n%20sobre%20IndicadoresVIP%20📈';
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-dark/80 backdrop-blur-lg border-b border-white/5 py-4' : 'bg-transparent py-6'}`} data-id="element-146">
      <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-147">
        <a href="#" className="flex items-center gap-2 group" data-id="element-148">
          <div className="w-10 h-10 rounded-lg bg-gold/10 flex items-center justify-center border border-gold/20 group-hover:border-gold/40 transition-colors" data-id="element-149">
            <TrendingUp className="text-gold w-6 h-6" data-id="element-150" />
          </div>
          <span className="font-heading font-bold text-xl tracking-tight text-white" data-id="element-151">
            Indicadores<span className="text-gold" data-id="element-152">VIP</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-153">
          <a href="#beneficios" className="text-sm font-medium text-zinc-300 hover:text-white transition-colors" data-id="element-154">
            Beneficios
          </a>
          <a href="#guia" className="text-sm font-medium text-zinc-300 hover:text-white transition-colors" data-id="element-155">
            Guía Gratis
          </a>
          <a href="#testimonios" className="text-sm font-medium text-zinc-300 hover:text-white transition-colors" data-id="element-156">
            Testimonios
          </a>

          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 hover:border-gold/50 transition-all duration-300 text-sm font-medium" data-id="element-157">
            <MessageCircle className="w-4 h-4 text-gold" data-id="element-158" />
            <span data-id="element-159">Hablar por WhatsApp</span>
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-160">
          {mobileMenuOpen ? <X data-id="element-161" /> : <Menu data-id="element-162" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-163">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-dark border-b border-white/10 overflow-hidden" data-id="element-164">
            <div className="flex flex-col px-6 py-4 space-y-4" data-id="element-165">
              <a href="#beneficios" onClick={() => setMobileMenuOpen(false)} className="text-zinc-300 py-2" data-id="element-166">
                Beneficios
              </a>
              <a href="#guia" onClick={() => setMobileMenuOpen(false)} className="text-zinc-300 py-2" data-id="element-167">
                Guía Gratis
              </a>
              <a href="#testimonios" onClick={() => setMobileMenuOpen(false)} className="text-zinc-300 py-2" data-id="element-168">
                Testimonios
              </a>
              <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 px-5 py-3 rounded-lg bg-gold text-dark font-semibold mt-4" data-id="element-169">
                <MessageCircle className="w-5 h-5" data-id="element-170" />
                <span data-id="element-171">Hablar por WhatsApp</span>
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
}